import { waitForElements, headerTransition, updateBodyPaddingTop, getElementOrParentByClassName } from '../helpers/utils';
import { openWishlist, renderWishlistCounter } from '../services/wishlist.service';
import { Carousel } from './Carousel';
import { hideOverlay, showOverlay, whenNotShownInOverlay } from './Overlay';
import { SEARCH_CLOSE } from '../constants/events.constants';
import { isDesktop } from '../constants/devices.constants';
import { updateSidePanelBannerOffset } from '../helpers/side-panel-banner';
export default (() => {
    console.log('UNTUCKit : Module : Nav : loaded');
    let navOpen = false;
    const pageRoots = () => [document.documentElement, document.body];
    function dismiss() {
        if (!navOpen) {
            return;
        }
        document.querySelector('.js-nav')?.classList.remove('is-active');
        pageRoots().forEach((root) => root.classList.remove('nav-opened'));
        document.querySelectorAll('.m-menu__checkbox').forEach((input) => {
            input.checked = false;
        });
        navOpen = false;
    }
    function close() {
        if (!navOpen) {
            return;
        }
        dismiss();
        hideOverlay();
    }
    function open() {
        if (!navOpen) {
            pageRoots().forEach((root) => root.classList.add('nav-opened'));
            updateSidePanelBannerOffset();
            document.querySelector('.js-nav')?.classList.add('is-active');
            navOpen = true;
            showOverlay('mobile-nav');
        }
    }
    const bindUIActions = function () {
        console.log('bindUIActions');
        document.querySelector('.js-nav')?.addEventListener('touchmove', (event) => {
            event.stopPropagation();
        });
        document.querySelector('.js-show-nav')?.addEventListener('click', (event) => {
            event.preventDefault();
            event.stopPropagation();
            toggle();
        });
        document.addEventListener('click', function (e) {
            const target = e.target;
            if (getElementOrParentByClassName(target, 'js-hide-nav')) {
                close();
            }
        });
        // desktop and mobile carousels are rendered at different times
        waitForElements(".mobile-nav .js-utk-carousel").then((els) => handleCarousels(els, "mobile")).catch(() => { });
        const bottomBar = document.querySelector(".header__bottom-bar");
        headerTransition.subscribe((smallerHeader) => {
            if (smallerHeader) {
                if (bottomBar) {
                    const bottomBarHeight = bottomBar.offsetHeight;
                    updateBodyPaddingTop(bottomBarHeight);
                    bottomBar.classList.add("header__bottom-bar--hidden");
                }
            }
            else if (bottomBar) {
                bottomBar.classList.remove("header__bottom-bar--hidden");
            }
        });
        whenNotShownInOverlay('mobile-nav').subscribe(() => dismiss());
        let bannerOffsetFrame = 0;
        window.addEventListener('resize', () => {
            if (!navOpen) {
                return;
            }
            // The hamburger is hidden from the desktop breakpoint up. Close an open
            // menu when the window grows into that range so scroll lock is released.
            if (isDesktop()) {
                close();
                return;
            }
            cancelAnimationFrame(bannerOffsetFrame);
            bannerOffsetFrame = requestAnimationFrame(updateSidePanelBannerOffset);
        });
        document.addEventListener('click', (e) => {
            const target = e.target;
            // close mobile nav when chat link is clicked
            if (getElementOrParentByClassName(target, 'open_chat') && target.closest('.mobile-nav')) {
                e.preventDefault();
                close();
            }
            const wishlistLink = getElementOrParentByClassName(target, 'js-open-wishlist');
            if (wishlistLink && wishlistLink.closest('.mobile-nav')) {
                e.preventDefault();
                openWishlist();
                close();
            }
        });
    };
    function toggle() {
        if (document.querySelector('.nav-opened')) {
            close();
        }
        else {
            open();
        }
    }
    function init() {
        console.log('UNTUCKit : Module : Nav : init');
        bindUIActions();
        renderWishlistCounter();
    }
    return { init };
})();
function handleCarousels(els, device) {
    Array.from(els).forEach((el) => {
        new Carousel(el, { rotation: el.dataset.rotation }, device).setup();
    });
}
document.addEventListener("click", handleMobileMenuBackClick);
document.addEventListener("change", handleMobileTopLevelAccordionChange);
document.addEventListener("click", handleMobileSearchIconClick);
document.addEventListener("click", handleDesktopSearchIconClick);
document.addEventListener(SEARCH_CLOSE, handleDesktopSearchFormCloseClick);
function handleMobileTopLevelAccordionChange(e) {
    const target = e.target;
    if (!(target instanceof HTMLInputElement)) {
        return;
    }
    if (!target.classList.contains('m-menu__checkbox--top-level') || !target.closest('.mobile-nav')) {
        return;
    }
    if (!target.checked) {
        return;
    }
    const topLevelInputs = document.querySelectorAll('.mobile-nav .m-menu__checkbox--top-level');
    topLevelInputs.forEach((accordionInput) => {
        if (accordionInput !== target) {
            accordionInput.checked = false;
        }
    });
}
function handleMobileSearchIconClick(e) {
    const target = e.target;
    const searchButton = getElementOrParentByClassName(target, "header-actions__search-button-mobile");
    if (searchButton) {
        const mobileSearchFormContainer = document.querySelector(".header__mobile-search-form-container");
        if (mobileSearchFormContainer) {
            searchButton.classList.toggle('header-actions__search-button-mobile--active');
            mobileSearchFormContainer.classList.toggle('header__mobile-search-form-container--open');
            if (mobileSearchFormContainer.classList.contains('header__mobile-search-form-container--open')) {
                mobileSearchFormContainer.removeAttribute('inert');
                const searchForm = mobileSearchFormContainer.querySelector('input');
                if (searchForm) {
                    searchForm.focus();
                }
            }
            else {
                mobileSearchFormContainer.setAttribute('inert', '');
            }
        }
    }
}
function handleMobileMenuBackClick(e) {
    const menuToggleEl = getElementOrParentByClassName(e.target, 'm-menu__toggle');
    if (menuToggleEl) {
        const inputId = menuToggleEl.dataset.inputId;
        if (inputId) {
            const inputEl = document.getElementById(inputId);
            if (inputEl) {
                inputEl.checked = false;
            }
        }
    }
}
function handleDesktopSearchIconClick(e) {
    const target = e.target;
    const searchButton = getElementOrParentByClassName(target, "header-actions__search-button-desktop");
    if (searchButton) {
        const parent = searchButton.parentElement;
        const searchFormContainer = parent.querySelector(".header-actions__search-form-container");
        if (searchFormContainer) {
            searchButton.classList.toggle('header-actions__search-button-desktop--active');
            if (searchFormContainer.classList.contains('header-actions__search-form-container--hidden')) {
                searchFormContainer.classList.remove('header-actions__search-form-container--hidden');
                searchFormContainer.removeAttribute('inert');
                const searchForm = parent.querySelector('search-form');
                if (searchForm) {
                    searchForm.setFocus({ preventScroll: true });
                }
                else {
                    const searchInput = parent.querySelector('input');
                    if (searchInput) {
                        searchInput.focus({ preventScroll: true });
                    }
                }
            }
            else {
                document.dispatchEvent(new CustomEvent(SEARCH_CLOSE));
            }
        }
    }
}
function handleDesktopSearchFormCloseClick() {
    const searchFormContainer = document.querySelector(".header-actions__search-form-container");
    if (searchFormContainer) {
        searchFormContainer.classList.add("header-actions__search-form-container--hidden");
        searchFormContainer.setAttribute('inert', '');
    }
    const searchButton = document.querySelector(".header-actions__search-button-desktop");
    if (searchButton) {
        searchButton.focus({ preventScroll: true });
    }
}
